import { render, staticRenderFns } from "./RegistrationViewGlobal.vue?vue&type=template&id=6e00c18d&"
import script from "./RegistrationViewGlobal.vue?vue&type=script&lang=js&"
export * from "./RegistrationViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports